import { forwardRef } from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

import {
  DROPDOWN_MENU_SUB_TRIGGER_ICON,
  type TDropdownMenuSubTriggerElement,
  type TDropdownMenuSubTriggerProps,
} from "@/ui/components/overlay/DropdownMenu/DropdownMenu.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { TextBody } from "@/ui/components/typography/TextBody";
import { cn } from "@/ui/lib/utils";

export const DropdownMenuSubTrigger = forwardRef<TDropdownMenuSubTriggerElement, TDropdownMenuSubTriggerProps>(
  (
    {
      children,
      className,
      icon,
      inset,
      ...props
    },
    ref,
  ) => (
    <DropdownMenuPrimitive.SubTrigger
      data-component="DropdownMenuSubTrigger"
      ref={ref}
      className={cn(
        "relative flex w-full cursor-default select-none items-center gap-2 rounded-sys-sm py-1.5 pr-8 outline-none transition-colors",
        icon || inset ? "pl-8" : "pl-2",
        "focus:bg-component-select-item-focused focus:text-foreground-default",
        "data-[state=open]:bg-component-select-item-focused data-[state=open]:text-foreground-default",
        className,
      )}
      {...props}
    >
      { icon ? (
        <span
          data-component="DropdownMenuSubTriggerIcon"
          className="absolute left-2 flex h-4 w-4 items-center justify-center"
        >
          <Icon icon={icon} aria-hidden="true" size="sm" />
        </span>
      ) : null }
      <TextBody tag="span" size={3} color="inherit" isResponsive={false}>
        { children }
      </TextBody>
      <span
        data-component="DropdownMenuSubTriggerIndicator"
        className="absolute right-2 flex h-4 w-4 items-center justify-center"
      >
        <Icon icon={DROPDOWN_MENU_SUB_TRIGGER_ICON} aria-hidden="true" size="sm" />
      </span>
    </DropdownMenuPrimitive.SubTrigger>
  ),
);

DropdownMenuSubTrigger.displayName = DropdownMenuPrimitive.SubTrigger.displayName;
